import {
  Action,
  ActionType,
  ISecondSectionResponse,
} from "models/dashboard/secondSection";
import createReducer from "../../createReducer";

export interface SecondSectionReducerType {
  loading: boolean;
  error?: string;
  secondSectionResponse?: ISecondSectionResponse;
}

const defaultState: SecondSectionReducerType = {
  loading: false,
  error: undefined,
  secondSectionResponse: undefined,
};

export const getSecondSectionReducer = createReducer<SecondSectionReducerType>(
  defaultState,
  {
    [ActionType.GET_SECOND_SECTION_DATA](state: SecondSectionReducerType) {
      return {
        ...state,
        loading: true,
      };
    },

    [ActionType.GET_SECOND_SECTION_DATA_ERROR](
      state: SecondSectionReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },

    [ActionType.GET_SECOND_SECTION_DATA_SUCCESS](
      state: SecondSectionReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: null,
        secondSectionResponse: action.payload,
      };
    },
  }
);
